import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CurrencyInputField, InterestInputField } from 'components/form';

import { DealSheetFormValues, LineItemSection } from '../types';

interface Props {
  rowIndex: number;
  section: LineItemSection;
}

export const LineItemAmountCell = ({ rowIndex, section }: Props) => {
  const { control } = useFormContext<DealSheetFormValues>();

  const amountType = useWatch({ control, name: `${section}.${rowIndex}.amountType` });

  if (amountType === 'percent') {
    return (
      <InterestInputField
        label="Amount"
        control={control}
        name={`${section}.${rowIndex}.amount`}
        textFieldProps={{ variant: 'outlined' }}
      />
    );
  }

  return (
    <CurrencyInputField
      label="Amount"
      control={control}
      allowNegative
      name={`${section}.${rowIndex}.amount`}
      textFieldProps={{ variant: 'outlined' }}
    />
  );
};
